import { capitalize } from 'lodash';
import { ReactElement } from 'react';

import { GrDocumentVerified } from 'react-icons/gr';

import AlternativeEnvironmentButtonBase from './AlternativeEnvironmentButtonBase';

import { AlternativeEnvironmentButtonProps } from './types';

export default function AcceptanceEnvironmentButton({
  url,
  title,
  badgeContent,
  appName,
  appTitle,
}: AlternativeEnvironmentButtonProps): ReactElement {
  return (
    <AlternativeEnvironmentButtonBase
      title={
        title ||
        `Klik hier voor de acceptatie omgeving van ${
          appTitle || capitalize(appName)
        }`
      }
      icon={GrDocumentVerified}
      url={url}
      badgeContent={badgeContent}
    />
  );
}
